import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";

import "./multiAreachart.style.scss";

class MultiAreaChart extends Component {
  state = {
    margin: { top: 20, right: 20, bottom: 30, left: 40 },
    bisectDate: d3.bisector(d => d.x).left
  };

  componentDidMount() {
    this.displayChart(this.props);
  }

  componentWillReceiveProps(nextprops) {
    if (
      nextprops.width !== this.props.width ||
      this.props.vLinePoint !== nextprops.vLinePoint
    ) {
      $(`#${this.props.id}`).empty();
      this.displayChart(nextprops);
    }
  }

  // cal_data = () => {
  //   let data = [];
  //   let year = new Date().getFullYear();

  //   for (let i = year; i <= year + 50; i++) {
  //     let obj = {};
  //     obj["x"] = i;

  //     if (i <= 2026) {
  //       obj["y1"] = 80;
  //       obj["y2"] = 20;
  //     } else if (i <= 2033) {
  //       obj["y1"] = 60;
  //       obj["y2"] = 40;
  //     } else if (i <= 2040) {
  //       obj["y1"] = 30;
  //       obj["y2"] = 70;
  //     } else if (i <= 2075) {
  //       obj["y1"] = 10;
  //       obj["y2"] = 90;
  //     }
  //     data.push(obj);
  //   }

  //   return data;
  // };

  displayChart = props => {
    const { margin, bisectDate } = this.state;
    const { id, width, data, vLinePoint } = props;

    // let data = this.cal_data();

    const w = width - margin.left - margin.right,
      height = 500 - margin.top - margin.bottom;

    const x = d3.scale
      .linear()
      .domain([d3.min(data, d => d.x), d3.max(data, d => d.x)])
      .range([0, w]);

    const y = d3.scale
      .linear()
      .domain([
        0,
        d3.max(data, function(d) {
          let x = [];
          x.push(d.y1);
          x.push(d.y2);
          return d3.max(x);
        })
      ])
      .range([height, 0]);

    const xAxis = d3.svg
      .axis()
      .scale(x)
      .orient("bottom")
      .tickFormat(d3.format(".2"));

    const yAxis = d3.svg
      .axis()
      .scale(y)
      .orient("left");
    // .tickFormat(d3.format("+.0%"));

    const area1 = d3.svg
      .area()
      .x(data => x(data.x))
      .y0(height)
      .y1(data => y(data.y1));

    const area2 = d3.svg
      .area()
      .x(data => x(data.x))
      .y0(height)
      .y1(data => y(data.y2));

    const svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg
      .append("g")
      .attr("class", "parent2")
      .append("path")
      .datum(data)
      .attr("class", "area2")
      .attr("fill", "#36aeafa6")
      .attr("d", area2);

    svg
      .append("g")
      .attr("class", "parent1")
      .append("path")
      .datum(data)
      .attr("class", "area1")
      .attr("fill", "#f9d057b3")
      .attr("d", area1);

    d3.select(".parent1")
      .append("text")
      .attr("class", "rectangle_label")
      .text("Equity")
      .attr("x", 10)
      .attr("y", 20);

    d3.select(".parent2")
      .append("text")
      .attr("class", "rectangle_label")
      .text("Fixed Income")
      .attr("x", w - 100)
      .attr("y", 20);

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    svg
      .append("g")
      .attr("class", "y axis")
      .call(yAxis);

    //  Verticle line
    const vLine = svg.append("g").attr("class", "verticleLine");
    vLine
      .append("line")
      .attr("x1", x(vLinePoint))
      .attr("y1", 0)
      .attr("x2", x(vLinePoint))
      .attr("y2", height)
      .style("stroke-width", 0.75)
      .style("stroke", "#4a4a4a")
      .style("fill", "none");

    vLine
      .append("text")
      .text("Retirement")
      .attr("dy", ".35em")
      .attr("transform", `translate(${x(vLinePoint - 1)},80) rotate(270)`)
      .style("font-size", "14px")
      .style("fill", "#4a4a4a");

    // ************ Tooltip *****************
    var pathLine = svg
      .append("g")
      .attr("class", "pathLine")
      .style("display", "none");

    pathLine
      .append("path") // vertical line to follow mouse
      .attr("id", `focus-path`)
      .style("stroke", "#999999")
      .style("stroke-width", "1px");

    var tooltipHolder = svg
      .append("g")
      .attr("class", "tooltipHolder")
      .style("display", "none");

    this.toolTip_svg([svg, tooltipHolder]);

    svg
      .append("rect")
      .attr("class", "overlay")
      .attr("width", w)
      .attr("height", height)
      .on("mouseover", function() {
        pathLine.style("display", null);
        tooltipHolder.style("display", null);
      })
      .on("mouseout", function() {
        pathLine.style("display", "none");
        tooltipHolder.style("display", "none");
      })
      .on("mousemove", mousemove);

    function mousemove() {
      var mouse = d3.mouse(this);

      // console.log(mouse, x);

      var x0 = x.invert(mouse[0]);

      var i = bisectDate(data, x0, 1);
      var d0 = data[i - 1];
      var d1 = data[i];

      if (d0 && d1 && d0["x"] && d1["x"]) {
        var d = x0 - d0["x"] > d1["x"] - x0 ? d1 : d0;

        // console.log(d);

        let xTransform = x(d["x"]) >= width / 2 ? x(d["x"] - 10) : x(d["x"]);

        let pathTransform =
          x(d["x"]) < width / 3.5
            ? x(d["x"])
            : x(d["x"]) < width / 2.5
            ? x(d["x"] - 3)
            : x(d["x"]) >= width / 1.6
            ? x(d["x"] - 5)
            : x(d["x"]);

        pathLine.attr(
          "transform",
          "translate(" + pathTransform + "," + 0 + ")"
        );

        tooltipHolder.attr(
          "transform",
          "translate(" + xTransform + "," + 0 + ")"
        );

        // let sup =
        //   d.date === 1 ? "st" : d.date === 2 ? "nd" : d.date === 3 ? "rd" : "th";

        d3.select(`#text-one`).text(d["x"]);
        d3.select(`#text-two`).text(`Equity ${d["y1"]}%`);
        d3.select(`#text-three`).text(`Fixed Income ${d["y2"]}%`);

        d3.select(`#focus-path`).attr("d", function() {
          var d = "M" + i + "," + height;
          d += " " + i + "," + 40;

          // console.log(d);
          return d;
        });
      }
    }
  };
  toolTip_svg = props => {
    var svg = props[0],
      tooltipHolder = props[1];
    svg
      .append("g")
      .attr("class", "tooltipHolder")
      .style("display", "none");

    tooltipHolder
      .append("rect")
      .attr("y", 27)
      .attr("width", 115)
      .attr("height", 55)
      .style("fill", "#000000db");

    tooltipHolder
      .append("text")
      .attr("id", `text-one`)
      .attr("x", 10)
      .attr("y", 35)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#fff");

    tooltipHolder
      .append("text")
      .attr("id", `text-two`)
      .attr("x", 10)
      .attr("y", 50)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#f9d057");

    tooltipHolder
      .append("text")
      .attr("id", `text-three`)
      .attr("x", 10)
      .attr("y", 65)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#36aeaf");
  };
  render() {
    const { id } = this.props;
    return <div id={id}></div>;
  }
}
export default MultiAreaChart;



// WEBPACK FOOTER //
// ./src/components/d3Components/multiAreaChart/multiAreaChart.jsx